<div class="table-container"
    animate.enter="ds-fade-enter" animate.leave="ds-fade-leave">
    <h1>{{ 'ACTIVITY.ActivitiesToday' | translate }}</h1>
    <div class="ds-table-wrapper"
        [dsScrollContent]="controller()"
        [rowSteps]="true">
        <table>
            <thead>
                <tr>
                    <th>{{ 'ACTIVITY.ActivitiesTableStart' | translate }}</th>
                    <th>{{ 'ACTIVITY.ActivitiesTableTitle' | translate }}</th>
                    <th>{{ 'ACTIVITY.ActivitiesTableLocation' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                @for (activity of activities(); track activity.id; let i = $index) {
                <tr [id]="'activity' + i">
                    <td>
                        <span [class.strike]="activity.stateId === cancelled">
                            <span>{{ activity.startTime }}</span>
                        </span>
                    </td>
                    <td>
                        <div class="table-item-title">
                            <span [class.strike]="activity.stateId === cancelled">
                                <span class="table-item-title-content">{{ activity.title }}</span>
                            </span>
                            @if (activity.hasZoom) {
                            <img src="assets/images/zoom-icon.png"
                                alt="zoom-icon"
                                class="table-icon" />
                            }
                            @if (activity.hasYoutube) {
                            <img src="assets/images/youtube-icon.png"
                                alt="youtube-icon"
                                class="table-icon" />
                            }
                        </div>
                    </td>
                    <td>
                        <div class="location-wrapper">
                            @if (activity.stateId !== cancelled) {
                            <span class="location-name">{{ activity.location ? activity.location : '' }}</span>
                            }
                            @if (activity.stateId === cancelled) {
                            <span class="cancelled">{{ 'ACTIVITY.ActivitiesTableCancelled' | translate }}</span>
                            }
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>
